export function IconCompression() {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={25}
        height={24}
        fill="none"
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m15.5 15 6 6m-6-6v4.8m0-4.8h4.8M9.5 19.8V15m0 0H4.7m4.8 0-6 6M15.5 4.2V9m0 0h4.8m-4.8 0 6-6M9.5 4.2V9m0 0H4.7m4.8 0-6-6"
        />
    </svg>;
}
